import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { UserService, CountriesService } from '@app/_services';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import * as _ from 'lodash';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateHelper } from '@app/_helpers';
import { AddressFormComponent } from '../address-form/address-form.component';
import { IconComponent } from '../icon/icon.component';
import { FlexModule } from '@angular/flex-layout/flex';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-address-information',
    templateUrl: './address-information.component.html',
    styleUrls: ['./address-information.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, FlexModule, IconComponent, AddressFormComponent, TranslateModule]
})
export class AddressInformationComponent implements OnInit {

    constructor(public bsModalRef: BsModalRef,
        private userService: UserService,
        private countriesService: CountriesService,
        private fb: UntypedFormBuilder,
        private toastr: ToastrService,
        public translate: TranslateService,
        public translateHelper: TranslateHelper,
    ) { }

    @Input()
    form = this.fb.group({
        _id: [null],
        title: [null, [Validators.required]],
        name: [null, [Validators.required]],
        phone: [null, [Validators.required, Validators.pattern(/^[0-9+\-\s()]*$/)]],
        country: [null, [Validators.required, Validators.pattern(/[^((?!null).)*$]/)]],
        countryId: [null],
        area: [null],
        areaId: [null],
        city: [null, [Validators.required, Validators.pattern(/[^((?!null).)*$]/)]],
        cityId: [null],
        address1: [null],
        address2: [null],
        location: this.fb.group({
            longitude: [50.5440691369832],
            latitude: [26.1005374683495],
        }),
        building: [null, [Validators.required]],
        block: [null, [Validators.required]],
        flat: [null],
        road: [null, [Validators.required]],
        governorate: [null]
    });

    public onClose: Subject<boolean>;
    lang;
    addressData;
    type;
    userId;
    countries = [];
    country;

    ngOnInit(): void {
        this.onClose = new Subject();
        // Initialize addressData if not provided (for new addresses)
        if (!this.addressData) {
            this.addressData = {};
        }
    }

    updateAddress() {
        this.checkForm();
        if (this.form.invalid || !this.checkForm()) return;
        this.userService.updateAddress(this.form.value).subscribe(() => {
            this.onClose.next(this.form.value);
            this.bsModalRef.hide();
        }, (error) => {
            console.log(error)
        })
    }

    addAddress() {
        this.checkForm();
        if (this.form.invalid || !this.checkForm()) return;
        this.userService.addAddress(this.form.value).subscribe((response) => {
            this.form.get('_id').setValue(response.addressId);
            this.onClose.next(this.form.value);
            this.bsModalRef.hide();
        }, (error) => {
            console.log(error)
        })
    }

    checkForm() {
        if (this.form.get("title").invalid) {
            this.toastr.error(this.translateHelper.getTranslation("title_is_required"));
            return false;
        }
        else if (this.form.get("name").invalid) {
            this.toastr.error(this.translateHelper.getTranslation("name_is_required"));
            return false;
        }
        else if (this.form.get("phone").invalid) {
            this.toastr.error(this.translateHelper.getTranslation("phone_is_required"));
            return false;
        }
        else if (this.form.get("countryId").invalid) {
            this.toastr.error(this.translateHelper.getTranslation("country_is_required"));
            return false;
        }
        else if (this.form.get("cityId").invalid) {
            this.toastr.error(this.translateHelper.getTranslation("city_is_required"));
            return false;
        }
        else if (this.form.get("building").invalid) {
            this.toastr.error(this.translateHelper.getTranslation("building_is_required"));
            return false;
        }
        else if (this.form.get("block").invalid) {
            this.toastr.error(this.translateHelper.getTranslation("block_is_required"));
            return false;
        }
        else if (this.form.get("road").invalid) {
            this.toastr.error(this.translateHelper.getTranslation("road_is_required"));
            return false;
        }
/* 
        if (_.includes(this.form.get("location").get("longitude").value.toString(), "50.54406913698")) {
            this.toastr.error(this.translateHelper.getTranslation("location_is_required"));
            return false;
        } */

        return true;
    }
}
